import React from 'react'

import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { ClusterCluster } from '@clinic/client'

import type { AdviceMap, PromqlSchemaMap } from '.'
import { AdviceLevel, ReportArgs } from '../../shared/types'
import { BENCHMARK_REPORT_NS } from '../translation'
import { AdvicePanel } from './MetricCategory'

interface AdviceSummaryProps {
  advices: AdviceMap
  promqlSchema: PromqlSchemaMap
  reportArgs: ReportArgs
  cluster?: ClusterCluster
}

export const AdviceSummary: React.FC<AdviceSummaryProps> = ({
  advices,
  promqlSchema,
  reportArgs,
  cluster
}) => {
  const adviceList = Object.values(advices).reduce((prev, cur) => {
    prev.push(...cur)
    return prev
  }, [])
  const { t } = useTranslation(BENCHMARK_REPORT_NS)
  if (!adviceList.length) {
    return (
      <Typography.Text type='success'>{t('tips.no_issue')}</Typography.Text>
    )
  }

  const errorAdvices = adviceList.filter((ad) => ad.level === AdviceLevel.Error)
  const warningAdvices = adviceList.filter(
    (ad) => ad.level === AdviceLevel.Warning
  )

  return (
    <AdvicePanel
      warningAdvices={warningAdvices}
      errorAdvices={errorAdvices}
      promqlSchema={promqlSchema}
      reportArgs={reportArgs}
      cluster={cluster}
    />
  )
}
